// Custom hook do carrinho do cardápio público — extraído VERBATIM de PublicMenu.js.
// Possui o estado `cart` e os handlers correlatos; recebe via props apenas as
// dependências externas (restaurant + 2 setters de modais).
import { useState } from 'react';

export default function usePublicMenuCart({ restaurant, setShowClosedStoreModal, setShowCartConfirmation }) {
  const [cart, setCart] = useState([]);

  const addToCart = (product, selectedAdditionals = {}, notes = '') => {
    // Check if restaurant is open or scheduling is available
    const isClosed = !restaurant?.status?.is_open || restaurant?.manually_closed;
    const schedulingEnabled = restaurant?.scheduling?.enabled;

    if (isClosed && !schedulingEnabled) {
      setShowClosedStoreModal(true);
      return;
    }

    const additionalsList = Object.values(selectedAdditionals).filter(add => add.quantity > 0);
    const additionalTotal = additionalsList.reduce((sum, add) => sum + (add.price * add.quantity), 0);

    const cartItem = {
      id: `${product.id}-${Date.now()}`,
      product,
      additionals: additionalsList,
      quantity: 1,
      totalPrice: product.price + additionalTotal,
      notes: notes || ''
    };
    setCart([...cart, cartItem]);
    setShowCartConfirmation(true);
  };

  const updateCartItemQuantity = (itemId, newQuantity) => {
    if (newQuantity <= 0) {
      setCart(cart.filter(item => item.id !== itemId));
    } else {
      setCart(cart.map(item => {
        if (item.id === itemId) {
          const additionalTotal = item.additionals.reduce((sum, add) => sum + (add.price * add.quantity), 0);
          return {
            ...item,
            quantity: newQuantity,
            totalPrice: (item.product.price + additionalTotal) * newQuantity
          };
        }
        return item;
      }));
    }
  };

  const clearCart = () => {
    setCart([]);
  };

  const getCartTotal = () => {
    return cart.reduce((sum, item) => sum + item.totalPrice, 0);
  };

  const getCartItemsCount = () => {
    return cart.reduce((sum, item) => sum + item.quantity, 0);
  };

  return {
    cart,
    setCart,
    addToCart,
    updateCartItemQuantity,
    clearCart,
    getCartTotal,
    getCartItemsCount
  };
}
